import React from 'react';

// Sports images imports
import f1poster from '../assets/sports/f1poster.jpg'
import maroc2025 from '../assets/sports/afcon25.webp'
import ligue1d from '../assets/sports/ligue1d.jpg'
import ligaEndesa from '../assets/sports/2.jpeg'
import eredevise from '../assets/sports/eredivisieposter.jpeg'
import nascarsports from '../assets/sports/nascarsports.jpg'
import nba from '../assets/sports/4.jpeg'
import motogp from '../assets/sports/motogp.jpg'
import ufc from '../assets/sports/ufc.jpg'
import sports6 from '../assets/sports/6.webp'
import rogerNadal from '../assets/sports/tennis.jpg'
import clasico from '../assets/sports/5.jpeg'
import euro2024 from '../assets/sports/euro24.jpg'
import olympic2024 from '../assets/sports/seriaitaly.webp'
import championsleague02 from '../assets/sports/championsleague02.jpg'
import carlosAlca from '../assets/sports/peremierleague.jpg'
import f1poster2 from '../assets/sports/f1poster2.jpeg'
import sports5 from '../assets/sports/5.jpeg'
import sports4 from '../assets/sports/4.jpeg'
import fifa2026 from '../assets/league/2026_FIFA_World_Cup.png'

// League logos imports
import uefaNations from '../assets/league/UEFA_Nations.png'
import primeiraLiga from '../assets/league/Primeira_Liga.png'
import mls from '../assets/league/MLS.png'
import f1 from '../assets/league/F1.png'
import motoGp from '../assets/league/Moto_Gp.png'
import copaDelRey from '../assets/league/LaLiga.png'
import championsLeague from '../assets/league/Logo_Champions_League.png'
import eredivisie from '../assets/league/Jupiler_Pro_League.png'
import rsl from '../assets/league/rsl.png'
import bundesliga from '../assets/league/Bundesliga.png'
import serieA from '../assets/league/Serie_A.png'
import laLiga from '../assets/league/LaLiga.png'
import premierLeague from '../assets/league/Premier_League.png'
import uefaEuropaLeague from '../assets/league/UEFA_Europa_League.png'
import fifa2026League from '../assets/league/2026_FIFA_World_Cup.png'



export default function Sports(){

    // League logos data
    const leagues = [
        { name: "Champions League", logo: championsLeague },
        { name: "Premier League", logo: premierLeague },
        { name: "La Liga", logo: laLiga },
        { name: "Serie A", logo: serieA },
        { name: "Bundesliga", logo: bundesliga },
        { name: "UEFA Europa League", logo: uefaEuropaLeague },
        { name: "UEFA Nations", logo: uefaNations },
        { name: "Copa del Rey", logo: copaDelRey },
        { name: "FIFA World Cup 2026", logo: fifa2026League },
        { name: "Eredivisie", logo: eredivisie },
        { name: "Primeira Liga", logo: primeiraLiga },
        { name: "MLS", logo: mls },
        { name: "F1", logo: f1 },
        { name: "Moto GP", logo: motoGp },
        { name: "RSL", logo: rsl }
    ];

    // Sports events data
    const sportsEvents = [
        { id: 1, title: "F1 Championship", image: f1poster },
        { id: 2, title: "Maroc 2025", image: maroc2025 },
        { id: 4, title: "Liga Endesa", image: ligaEndesa },
        { id: 5, title: "Eredivisie", image: eredevise },
        { id: 6, title: "NASCAR", image: nascarsports },
        { id: 7, title: "NBA", image: nba },
        { id: 8, title: "MotoGP", image: motogp },
        { id: 9, title: "UFC", image: ufc },
        { id: 10, title: "Événement Sportif", image: sports6 },
        { id: 11, title: "Roger Nadal", image: rogerNadal },
        { id: 12, title: "El Clásico", image: clasico },
        { id: 13, title: "Euro 2024", image: euro2024 },
        { id: 14, title: "Olympic 2024", image: olympic2024 },
        { id: 15, title: "Champions League", image: championsleague02 },
        { id: 16, title: "Carlos Alcaraz", image: carlosAlca },
        { id: 17, title: "F1 Poster", image: f1poster2 },
        { id: 18, title: "Événement Sportif", image: sports5 },
        { id: 19, title: "Événement Sportif", image: sports4 },
        { id: 20, title: "FIFA World Cup 2026", image: fifa2026 },
        { id: 21, title: "Ligue 1", image: ligue1d },
    ];


    return(
        <>
        <section className="series-section relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-20">
                    <div className="h-64 w-full" style={{
                        backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>
            <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto">
            <div className="text-center mt-12">
                <h1 className="text-2xl md:text-3xl lg:text-4xl mx-auto font-extrabold text-blue-900 mb-4 max-w-3xl leading-snug text-center">
                    Sports en direct et événements sportifs du monde entier
                </h1>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                    Profitez des meilleures ligues, compétitions et événements sportifs en qualité HD/4K
                </p>
            </div>
            {/* Sports Events Carousel - Left to Right */}
            <div className="mt-5">
                <div className="relative overflow-hidden">
                    <div className="flex space-x-6 pb-5 carousel-sports">
                        {[...sportsEvents, ...sportsEvents, ...sportsEvents].map((event, index) => (
                            <div key={`${index}-${Math.random()}`} className="flex-shrink-0 carousel-item">
                                <div className="relative w-48 h-80 rounded-lg overflow-hidden shadow-lg">
                                    <img 
                                        src={event.image}
                                        alt={event.title}
                                        className="w-full h-full object-cover carousel-image"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* Leagues Carousel - Right to Left */}
            <div className="mt-5"> 
                <div className="relative overflow-hidden">
                    <div className="flex space-x-8 carousel-leagues">
                        {[...leagues, ...leagues, ...leagues].map((league, index) => (
                            <div key={`${index}-${Math.random()}`} className="flex-shrink-0 flex items-center justify-center carousel-item">
                                <div className="w-24 h-16 flex items-center justify-center p-2">
                                    <img 
                                        src={league.logo} 
                                        alt={league.name}
                                        className="max-w-full max-h-full object-contain carousel-image"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            </div>
        </section>
        </>
    )
}